import {
  type InfiniteData,
  type QueryFunctionContext,
  type UseInfiniteQueryResult,
  useInfiniteQuery,
} from '@tanstack/react-query';

import { tenantService } from '@/services/tenant-service';
import type { Tenant } from '@/types/core/tenant';
import type { Page } from '@/types/shared/page';

import { tenantQueryKeys } from './query-keys';

/**
 * List tenants visible to the current user.
 * Accepts optional paging args via `opts`.
 */
export function useListTenants(opts?: {
  limit?: number;
  next?: string;
  filter?: string;
}): UseInfiniteQueryResult<InfiniteData<Page<Tenant>, unknown>, Error> {
  return useInfiniteQuery<
    Page<Tenant>,
    Error,
    InfiniteData<Page<Tenant>, unknown>
  >({
    queryKey: tenantQueryKeys.list(opts?.limit, opts?.filter),
    queryFn: (context: QueryFunctionContext) => {
      const pageParam = context.pageParam as string | undefined;
      return tenantService.listTenants({
        limit: opts?.limit,
        next: pageParam,
        filter: opts?.filter,
      });
    },
    initialPageParam: opts?.next ?? undefined,
    getNextPageParam: (last) => last.next ?? undefined,
    getPreviousPageParam: (first) => first.prev ?? undefined,
  });
}
